"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconTrash = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M47.75 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM39.25 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM30.75 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM22.25 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6z"
  }), _react["default"].createElement("path", {
    d: "M54.06 11.85h-9.54V10.4a4.77 4.77 0 0 0-4.77-4.77h-9.5a4.77 4.77 0 0 0-4.77 4.77v1.44h-9.54a6.54 6.54 0 0 0-6.54 6.54v3A1.6 1.6 0 0 0 11 23h2.65v34.7a5.94 5.94 0 0 0 5.93 5.93h30.84a5.94 5.94 0 0 0 5.93-5.93V23H59a1.6 1.6 0 0 0 1.6-1.6v-3a6.54 6.54 0 0 0-6.54-6.55zm-.91 45.85a2.74 2.74 0 0 1-2.73 2.73H19.58a2.74 2.74 0 0 1-2.73-2.73V23h36.3zM12.6 18.38A3.34 3.34 0 0 1 15.94 15h38.12a3.34 3.34 0 0 1 3.34 3.34v1.38H12.6zm16.08-8a1.57 1.57 0 0 1 1.57-1.57h9.5a1.57 1.57 0 0 1 1.57 1.57v1.44H28.68z"
  })),
  height: undefined,
  width: undefined
});
IconTrash.displayName = 'IconTrash';
var _default = IconTrash;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/trash.js
// module id = 61
// module chunks = 0